module.exports = __webpack_public_path__ + "static/media/NO_DECISION.3c744406.png";